import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import ParcoursFormFields from "../ParcoursFormFields";
import Button from "../../../components/Button";
import { useUpdateParcours } from "../../../../hooks/useUpdateParcours";
import { useAuth } from "../../../../auth/useAuth";
import { parcoursResponseToDto } from "../toDto";
import type { ParcoursDto, ParcoursResponse } from "../../../../api/parcoursApi";

export default function ParcoursInfoTab() {
  const { id = "" } = useParams<{ id: string }>();
  const parcours = useOutletContext<ParcoursResponse>();
  const { isAdmin } = useAuth();
  const update = useUpdateParcours(id);
  const [draft, setDraft] = useState<ParcoursDto | null>(null);

  useEffect(() => {
    setDraft(parcoursResponseToDto(parcours));
  }, [parcours]);

  if (!draft) return null;

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    update.mutate(draft);
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="bo-card">
        <ParcoursFormFields value={draft} onChange={setDraft} canEditPaid={isAdmin} />
      </div>
      <div style={{ marginTop: "var(--sp-5)", display: "flex", justifyContent: "flex-end", gap: "var(--sp-2)" }}>
        <Button type="submit" variant="primary" loading={update.isPending}>
          Enregistrer
        </Button>
      </div>
      {update.isSuccess && <p className="bo-success-text">Parcours mis à jour.</p>}
      {update.isError && <p className="bo-error-text">Erreur : {(update.error as Error)?.message}</p>}
    </form>
  );
}
